/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetEvalArtifactsRequest = {
  runId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetEvalArtifactsRequest$inboundSchema: z.ZodType<
  GetEvalArtifactsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  run_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "run_id": "runId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetEvalArtifactsRequest$Outbound = {
  run_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetEvalArtifactsRequest$outboundSchema: z.ZodType<
  GetEvalArtifactsRequest$Outbound,
  z.ZodTypeDef,
  GetEvalArtifactsRequest
> = z.object({
  runId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    runId: "run_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getEvalArtifactsRequestToJSON(
  getEvalArtifactsRequest: GetEvalArtifactsRequest,
): string {
  return JSON.stringify(
    GetEvalArtifactsRequest$outboundSchema.parse(getEvalArtifactsRequest),
  );
}
export function getEvalArtifactsRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetEvalArtifactsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetEvalArtifactsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetEvalArtifactsRequest' from JSON`,
  );
}
